import { JqueryHelperService } from './../../../jquery-helper.service';
import { Observable } from 'rxjs/Observable';
import { Component, Input, OnInit } from '@angular/core';
import { Product } from '../../../models/Product';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ActivatedRoute, Router } from '@angular/router';
import { IMAGE_BASE_URL } from '../../../app.constants';


@Component({
  selector: 'ciu-product-list-grid',
  templateUrl: './product-list-grid.component.html',
  styleUrls: ['./product-list-grid.component.css']
})
export class ProductListGridComponent implements OnInit {

  constructor(private jqueryHelper: JqueryHelperService, private route: ActivatedRoute, private router: Router) {
    this.jqueryHelper.setScrollPosition();
  }

  @Input() products$: Observable<Product[]>;
  @Input() type: string;

  onePageProducts: Product[];
  allProducts: Product[];
  itemsPerPage: number = 24;
  currentPage: number = 1;

  ngOnInit() {
    this.products$.subscribe(prod => {
      this.allProducts = prod;
      console.log('allPro', this.allProducts)
      this.allProducts.forEach(product => {
        if (product.image && product.image.includes('C:\\home\\site\\wwwroot\\')) {
          product.image = product.image.replace('C:\\home\\site\\wwwroot\\', IMAGE_BASE_URL);
        }
        if (product.company_logo && product.company_logo.includes('C:\\home\\site\\wwwroot\\')) {
          product.company_logo = product.company_logo.replace('C:\\home\\site\\wwwroot\\', IMAGE_BASE_URL);
        }
        product.images.forEach(image => {
          if (image.imageUrl  && image.imageUrl .includes('C:\\home\\site\\wwwroot\\')) {
          image.imageUrl = image.imageUrl.replace('C:\\home\\site\\wwwroot\\', IMAGE_BASE_URL);
          }
        })
      });
      this.onePageProducts = this.allProducts.slice(0, this.itemsPerPage)
      this.preloadImages();
    });

    const sub = this.route
      .queryParams
      .subscribe(params => {
        if (params['page']) {
          this.setPage(+params['page']);
        }
      });
  }


  images: any[] = [];
  preloadImages() {
    // this.onePageProducts.forEach(p => {
    //   p.images.forEach(img => {
    //     this.images.push(img.imageUrl);
    //     //     let image = new Image()
    //     //     image.src = img.imageUrl;

    //   })
    // })

  }

  pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.onePageProducts = this.allProducts.slice(startItem, endItem);
    this.jqueryHelper.scrollToTop();

    this.setQueryParam(event.page);
    this.currentPage = event.page;
  }

  setQueryParam(page) {
    //this.service
    let navString = '/home';

    if (this.router.url.includes('/home')) {
      navString = '/home';
    } else if (this.router.url.includes('/windows')) {
      navString = '/windows';
    }
    this.router.navigate([navString], { queryParams: { page: page } });
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/products-and-filter/product-list-grid/product-list-grid.component.ts